import * as React from "react"
import * as i18n from "tb-i18n"

import { Button } from "../../component/button"
import { getTransformStyle } from "../../../lib/util"
import { raf, RafFrame } from "../../../lib/util"

const styles = require("./apps-download.component.styl")

interface Props {}

interface States {
    pos: number
}

export class AppsDownload extends React.PureComponent<Props, States> {
    // 视差滚动的目标元素与位置
    private posStartTrigger: Element
    private posEndTrigger: Element
    private posStart: number
    private posEnd: number

    // 即将运行的 requestAnimateFrame 的引用
    private raf: RafFrame | null

    constructor(props: Props) {
        super(props)

        this.state = {
            pos: 0
        }
    }

    componentDidMount() {
        if (!this.checkIsSmallScreen()) {
            if (this.raf && this.raf.id) {
                raf.cancel(this.raf.id)
            }

            this.raf = raf.start(() => {
                this.raf = null
                this.parallaxScroll()
            }, 0)
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll)
        // 如果在 unmount 的时候, 还有未被执行的 raf 回调, 则清除
        if (this.raf) {
            raf.cancel(this.raf.id)
        }
    }

    private checkIsSmallScreen = () => {
        return window.innerWidth <= 768
    }

    private parallaxScroll = () => {
        setTimeout(() => {
            const scrollY = window.scrollY || window.pageYOffset
            const posStartTriggerCr = this.posStartTrigger.getBoundingClientRect()
            const posEndTriggerCr = this.posEndTrigger.getBoundingClientRect()
            this.posStart = posStartTriggerCr.top + scrollY - window.innerHeight
            this.posEnd = posEndTriggerCr.bottom + scrollY
            window.addEventListener("scroll", this.onScroll)
        }, 200)
    }

    private onScroll = () => {
        const scrollY = window.scrollY || window.pageYOffset
        if (scrollY > this.posStart && scrollY < this.posEnd) {
            const pos = scrollY - this.posStart
            this.setState({ pos })
        }
    }

    private onClickDownload = () => {
        window.open("/apps")
    }

    onConsult = () => {
        window.open("https://form.teambition.net/f/vxzwb9")
    }

    render() {
        const { pos } = this.state
        const dis = this.posEnd - this.posStart

        let iPadStyle = {}
        let macStyle = {}
        let shadowStyle = {}
        if (!this.checkIsSmallScreen()) {
            iPadStyle = {
                ...getTransformStyle(
                    `translate3d(0, -${(pos / dis) * 120}px, 0) rotate(-${(pos /
                        dis) *
                        12}deg)`
                )
            }
            macStyle = {
                ...getTransformStyle(
                    `translate3d(0, -${(pos / dis) * 100}px, 0) rotate(${(pos /
                        dis) *
                        12}deg)`
                )
            }
            shadowStyle = {
                ...getTransformStyle(`scale(${Math.max(1 - pos / dis, 0.8)})`)
            }
        }
        const startRef = el => {
            this.posStartTrigger = el
        }
        const endRef = el => {
            this.posEndTrigger = el
        }
        return (
            <section className={ styles["apps-download"] } ref={ startRef }>
                <div className={ styles["apps-download-wrap"] } ref={ endRef }>
                    <h2>{i18n.get("homepage.apps.download.title")}</h2>
                    <p>{i18n.get("homepage.apps.download.desc")}</p>

                    <Button
                        className="download-btn"
                        onClick={ this.onClickDownload }
                    >
                        {i18n.get("homepage.apps.download.link")}
                    </Button>
                    <Button
                        className="download-btn-mobile"
                        onClick={ this.onClickDownload }
                    >
                        {i18n.get("business.trial.download")}
                    </Button>
                    <div className="mobile" />
                    <div className="ipad" style={ iPadStyle } />
                    <div className="ipad-shadow" style={ shadowStyle } />
                    <div className="mac" style={ macStyle } />
                    <div className="mac-shadow" style={ shadowStyle } />
                </div>
            </section>
        )
    }
}
